
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 17.92c1.8-.22 3.35-.97 4.65-2.27 1.3-1.3 2.05-2.85 2.27-4.65h-3c-.22 1-.68 1.84-1.38 2.54-.7.7-1.54 1.16-2.54 1.38v3zM8 6h4l3 3h2.92c-.25-1.95-1.13-3.62-2.65-5C13.76 2.66 12 2 10 2c-2 0-3.76.66-5.27 2-1.52 1.38-2.4 3.05-2.65 5H5l3-3zm1 11.92v-3c-1-.22-1.84-.68-2.54-1.38-.7-.7-1.16-1.54-1.38-2.54h-3c.22 1.77.97 3.3 2.27 4.6 1.3 1.3 2.85 2.07 4.65 2.32zM10 0c2.75 0 5.1 1 7.05 2.95C19 4.9 20 7.25 20 10s-1 5.1-2.95 7.05C15.1 19 12.75 20 10 20s-5.1-1-7.05-2.95C1 15.1 0 12.75 0 10s1-5.1 2.95-7.05C4.9 1 7.25 0 10 0z"}})])
          )
        }
      }
    